import React from 'react';
import './chip.css';

interface FilterChipProps {
    label: string;
    active: boolean;
    onClick: () => void;
}

/** A toggle button for filters; wrap several in a `.chip-group`. */
const FilterChip = ({label, active, onClick}: FilterChipProps) => (
    <button type="button" className="chip" aria-pressed={active} onClick={onClick}>{label}</button>
);

export default FilterChip;
